<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">JSON Reader</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    ngbTooltip="Close"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>

<div class="modal-body" hsDraggable="modal-dialog">
  <textarea readonly class="form-control" rows="15">{{ json }}</textarea>
</div>
